let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kPQdW")).then(() => parcelRequire('80Zl0'));